<template>
  <div class="hs-page">
    <div class="hs-toolbar">
      <shipment-upload @uploaded="refreshTable" />
    </div>

    <general-table
      ref="shipmentTable"
      :api-url="apiUrl"
      :block-content="false"
      :view-content="false"
      :edit-content="false"
      :columns="columns"
      :type="type"
    >
      <template #cell(certificate_number)="data">
        <span class="hs-number">
          <span class="hs-number__icon">
            <feather-icon
              icon="AwardIcon"
              size="15"
            />
          </span>
          {{ data.item.certificate_number || '—' }}
        </span>
      </template>

      <template #cell(frontend_url)="data">
        <a
          v-if="data.item.frontend_url"
          :href="data.item.frontend_url"
          target="_blank"
          rel="noopener noreferrer"
          class="hs-btn hs-btn--outline"
        >
          <feather-icon
            icon="ExternalLinkIcon"
            size="14"
          />
          View
        </a>
        <span
          v-else
          class="hs-muted"
        >—</span>
      </template>

      <template #cell(download_certificate)="data">
        <a
          v-if="data.item.pdf && data.item.pdf.url"
          :href="data.item.pdf.url"
          target="_blank"
          rel="noopener noreferrer"
          class="hs-btn hs-btn--solid"
          :title="data.item.pdf.file_name"
        >
          <feather-icon
            icon="DownloadIcon"
            size="14"
          />
          PDF
        </a>
        <span
          v-else
          class="hs-btn hs-btn--disabled"
        >
          <feather-icon
            icon="FileTextIcon"
            size="14"
          />
          No file
        </span>
      </template>

      <template #cell(share_link)="data">
        <button
          type="button"
          class="hs-icon-btn"
          title="Copy certificate link"
          :disabled="!data.item.frontend_url"
          @click="copyLink(data.item.frontend_url)"
        >
          <feather-icon
            icon="LinkIcon"
            size="15"
          />
        </button>
      </template>
    </general-table>
  </div>
</template>

<script>
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import GeneralTable from '@/components/general-table/GeneralTable.vue'
import formatDate from '@/global-compositions/formatDate'
import ShipmentUpload from './ShipmentUpload.vue'

export default {
  components: {
    GeneralTable,
    ShipmentUpload,
  },
  data() {
    return {
      APIURL: '/halal/shipments',
      type: 'page',
      filter: {},
      columns: [
        { key: 'certificate_number', label: 'Certificate number' },
        { key: 'frontend_url', label: 'Certificate page' },
        { key: 'download_certificate', label: 'Certificate file' },
        { key: 'share_link', label: 'Share' },
        { key: 'actions' },
      ],
    }
  },

  computed: {
    apiUrl() {
      let base = '/halal/shipments?'

      if (!Object.values(this.filter).length) {
        return base.slice(0, -1)
      }

      // eslint-disable-next-line no-restricted-syntax
      for (const [key, value] of Object.entries(this.filter)) {
        if (key && value) {
          base += `${key}=${value}&`
        }
      }
      return base.slice(0, -1)
    },
  },
  methods: {
    refreshTable() {
      const table = this.$refs.shipmentTable
      if (table) table.getAllData(table.page || 1)
    },
    formatDateValue(value) {
      return formatDate(value) || value
    },
    async copyLink(url) {
      if (!url) return
      try {
        await navigator.clipboard.writeText(url)
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Link copied to clipboard',
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Could not copy the link',
            icon: 'BellIcon',
            variant: 'danger',
          },
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped src="./Shipment.scss"></style>
